@if (isLoaded()) {
  <app-loading-indicator [isLoading]="loadingServiceIsLoading"></app-loading-indicator>
  <div class="Flexbox Flexbox--column MainPage" [ngStyle]="themeStyles()">
    <app-top-bar></app-top-bar>
    <div class="Flexbox Flexbox--column SubContainer">
      <div class="Flexbox Flexbox--column Justify--space-between EditorContent">
        <div class="PreviewerContainer">
          <app-previewer class="Previewer" *ngIf="selectedPreviewerType === 'Preview'" [class.Dark]="shouldDarkenImage"></app-previewer>
          <!-- <button mat-fab class="RestartFAB" (click)="resetItem()"><mat-icon>restart_alt</mat-icon></button> -->
        </div>
        @if (!isSmallScreen()) {
          <div [class.Expanded]="!isCustomizerHidden()" [class.Hidden]="customizerWidth() === 0" [style.--right]="customizerWidthString()" class="HideButton">
            <button mat-icon-button (click)="toggleHideCustomizer()">
              <mat-icon>
                @if(isCustomizerHidden()) {
                  arrow_back_ios
                } @else {
                  arrow_forward_ios
                }
              </mat-icon>
            </button>
          </div>
        }
        <app-customizer-panel2 #customizer [canRetailerAddToCart]="isRetailerCartEnabled()" [class.Hidden]="isCustomizerHidden() && !isSmallScreen()" (selectedAttributesChange)="selectedAttributesChange($event)"></app-customizer-panel2>
        <!-- @if (!isRetailerOnly()) {
          <button class="MobileChatButton" mat-flat-button (click)="openChat()"><mat-icon>chat_bubble</mat-icon></button>
        } -->
      </div>
      <app-bottom-bar [canRetailerAddToCart]="isRetailerCartEnabled()"></app-bottom-bar>
    </div>
    @if (activeTopBarItem()?.key === 'explore') {
      <app-design-explorer></app-design-explorer>
    }
  </div>
} @else {
  <app-loading-indicator [isLoading]="true"></app-loading-indicator>
}
